import React from 'react';
import Modal from '../Modal/Modal';
import LineIcon from '../Icons/LineIcon';
import PreferencesMenu from './PreferencesMenu';

import './PreferencesDialog.css';

function PreferencesDialog({
  onClose,
  expandedReplies,
  bigThumbnails,
  preferences,
}) {
  return (
    <Modal
      className="PreferencesDialog"
      ariaLabelledBy="PreferencesDialog-title"
      onCloseRequest={onClose}
    >
      <section className="panel">
        <header>
          <h1 id="PreferencesDialog-title">Preferences</h1>
          <button
            className="close-button reset-button"
            type="button"
            onClick={onClose}
            aria-label="Close preferences"
            title="Close preferences"
          >
            <LineIcon type="cross" width={20} height={20} thickness={2} />
          </button>
        </header>
        <PreferencesMenu
          expandedReplies={expandedReplies}
          bigThumbnails={bigThumbnails}
          preferences={preferences}
        />
      </section>
    </Modal>
  );
}

export default PreferencesDialog;
